import React from 'react';
import styles from './CharacterProfile.module.css';
import EditableField from '../utils/EditableField';
import MatureTag from './MatureTag';
import { CharacterDetailResponse } from '../../api/types/chat';

interface EditableFieldState {
  isEditing: boolean;
  isLoading: boolean;
  isVisible: boolean;
  error: string | null;
  startEdit: (value: string) => void;
}

interface CharacterIconState {
  isVisible: boolean;
}

interface CharacterProfileHeaderProps {
  character: CharacterDetailResponse;
  displayName: EditableFieldState;
  tagline: EditableFieldState;
  characterIcon: CharacterIconState;
  isUpdating: boolean;
  handleStartChat: () => void;
  handleIconChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const CharacterProfileHeader: React.FC<CharacterProfileHeaderProps> = ({
  character,
  displayName,
  tagline,
  characterIcon,
  isUpdating,
  handleStartChat,
  handleIconChange
}) => {
  const renderDisplayName = (value: string): React.ReactNode => (
    <div className={styles.displayNameWrapper}>
      <h1 className={styles.displayName}>{value}</h1>
    </div>
  );

  const renderTagline = (value: string): React.ReactNode => (
    <p className={styles.tagline}>{value}</p>
  );

  return (
    <div className={styles.profileHeader}>
      <div className={styles.iconWrapper}>
        <img 
          src={character.icon} 
          alt={character.display_name} 
          className={styles.characterIcon}
        />
        {characterIcon.isVisible && (
          <label className={`${styles.editIconButton} ${isUpdating ? styles.updating : ''}`} htmlFor="icon-upload">
            {isUpdating ? (
              <div className={styles.spinner} />
            ) : (
              <span className={styles.editIconSymbol}>✎</span>
            )}
            <input
              type="file"
              id="icon-upload"
              accept="image/*"
              onChange={handleIconChange}
              style={{ display: 'none' }}
              disabled={isUpdating}
            />
          </label>
        )}
      </div>

      <div className={styles.displayNameContainer}>
        <div className={styles.displayNameWithVisibility}>
          <EditableField
            value={character.display_name}
            onEdit={displayName.startEdit}
            isEditing={displayName.isEditing}
            isLoading={displayName.isLoading}
            error={displayName.error}
            renderDisplay={renderDisplayName}
            containerClassName={styles.displayNameField}
            isVisible={displayName.isVisible}
          />
          {character.is_mature && !displayName.isEditing && <MatureTag />}
        </div>
      </div>

      <div className={styles.taglineContainer}>
        <EditableField
          value={character.tagline}
          onEdit={tagline.startEdit}
          isEditing={tagline.isEditing}
          isLoading={tagline.isLoading}
          error={tagline.error}
          renderDisplay={renderTagline}
          containerClassName={styles.taglineContainer}
          isVisible={tagline.isVisible}
        />
      </div>

      <div className={styles.chatButtonContainer}>
        <button 
          className={styles.chatButton}
          onClick={handleStartChat}
          type="button"
        >
          Start Chat
        </button>
      </div>
    </div>
  );
};

export default CharacterProfileHeader; 